import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { validateEnv, EnvValidationError } from "./lib/env-validation";
import { EnvErrorPage } from "./components/EnvErrorPage";

// Initialize Sentry first to capture any startup errors
initSentry();

try {
  validateEnv();
  createRoot(document.getElementById("root")!).render(<App />);
} catch (error) {
  if (error instanceof EnvValidationError) {
    createRoot(document.getElementById("root")!).render(
      <EnvErrorPage missingVars={error.missingVars} />
    );
  } else {
    throw error;
  }
}
